<template>
  <section :class="$s.TermsGeneratorContainer">
    <terms-generator-page
      :page-data="$store.state.pageContent"
      :terms-properties="termsProperties"
    />
  </section>
</template>

<script>
import TermsGeneratorPage from '~/components/terms-generator/shared/TermsGeneratorPage';
import { GET_PAGE_CONTENT } from '~/store/index';
import { WEEBLY_TOOLS_PRIVACY_POLICY } from '@weebly/aragorn-analytics/dist/constants/locations';

export default {
  layout: 'landing-page',

  components: {
    TermsGeneratorPage,
  },

  async fetch(context) {
    await context.store.dispatch(GET_PAGE_CONTENT, {
      context,
    });
  },

  head() {
    return (
      this.$store.state.pageContent &&
      this.$store.state.pageContent.meta
    ) || {};
  },

  data() {
    return {
      termsProperties: {
        createTermsClickEventName: 'create_privacy_policy',
        trackingLocation: WEEBLY_TOOLS_PRIVACY_POLICY,
        termsRetrievalPage: '/tools/privacy-policy',
        disclaimerLink: '/tools/template-terms',
        headerImage: 'privacy-policy',
      },
    };
  },
};
</script>

<style module="$s" lang="scss">
.TermsGeneratorContainer {
  margin: 0 auto;
}
</style>
